/*
 * @Description: '关于我们'页面所有路由
*/

export default [
    {
        path: 'company_info',
        component: resolve => require(['@/views/about/company_info'], resolve),
        name: 'company_info',
        meta: {
            nav: '关于我们'
        }
    },
  {
    path: 'main_team',
    component: resolve => require(['@/views/about/main_team'], resolve),
    name: 'main_team',
    meta: {
      nav: '主要团队'
    }
  },
  {
    path: 'contact',
    component: resolve => require(['@/views/about/contact'], resolve),
    name: 'contact',
    meta: {
      nav: '联系我们'
    }
  },
  {
    path: 'gather',
    component: resolve => require(['@/views/about/gather'], resolve),
    name: 'gather',
    meta: {
      nav: '英才聚集'
    }
  }

]



// WEBPACK FOOTER //
// ./src/router/about.js